import { useState } from "react";
import { Check, RefreshCw, BookOpen, X } from "lucide-react";
import { CategoryIcon } from "@/components/progress";

// DeedCard - Hauptkarte mit Tat (Normal-Modus nach Auswahl)
const DeedCard = ({
  displayDate,
  formatDate,
  currentDeedCategory,
  selectedDeedData,
  currentDeed,
  todayCompleted,
  showSuccess,
  isRamadanActive,
  islamicDate,
  t,
  onComplete,
  showChangeButton,
  onChangeClick
}) => {
  const [showTafsir, setShowTafsir] = useState(false);
  const deed = selectedDeedData || currentDeed;
  const hasTafsir = deed?.tafsir;

  return (
    <div className="deed-single-container">
      <div 
        className={`daily-card fade-in ${todayCompleted ? 'completed' : ''} ${showSuccess ? 'success-animation' : ''} ${isRamadanActive ? 'ramadan-card' : ''}`}
        data-testid="daily-card"
      >
        <div className="card-border-wrapper" aria-hidden="true"></div>
        <div className="todays-deed-label" data-testid="todays-deed-label">
          {t.todaysDeed}
        </div>
        
        <div className="date-display" data-testid="current-date">
          {formatDate(displayDate)}
          {isRamadanActive && islamicDate && (
            <div className="islamic-date" data-testid="islamic-date">
              {islamicDate.day}. {islamicDate.month} {islamicDate.year} H
            </div>
          )}
        </div>
        
        <div className="deed-content">
          <div className="deed-icon-wrapper">
            <CategoryIcon category={currentDeedCategory} size={24} />
          </div>
          <p className="deed-text" data-testid="deed-text">
            {deed?.text}
          </p>
        </div>
        
        <p className="source-reference" data-testid="source-reference">
          — {deed?.source}
          {hasTafsir && (
            <button
              className="tafsir-toggle"
              onClick={() => setShowTafsir(!showTafsir)}
              aria-label="Tafsir anzeigen"
              data-testid="tafsir-toggle"
            >
              <BookOpen size={12} />
            </button>
          )}
        </p>

        {showTafsir && hasTafsir && (
          <div className="tafsir-card fade-in" data-testid="tafsir-content">
            <button className="tafsir-close" onClick={() => setShowTafsir(false)} data-testid="tafsir-close">
              <X size={12} />
            </button>
            <p>{deed.tafsir}</p>
          </div>
        )}
        
        <div className="deed-actions">
          <button
            className={`action-btn ${todayCompleted ? 'completed' : ''} ${isRamadanActive ? 'ramadan-btn' : ''}`}
            onClick={onComplete}
            disabled={todayCompleted}
            aria-label={todayCompleted ? t.alreadyCompleted : t.markAsComplete}
            data-testid="complete-button"
          >
            <Check className="check-icon" />
            {todayCompleted ? t.completed : t.markComplete}
          </button>
          
          {showChangeButton && (
            <button
              className="change-deed-btn"
              onClick={onChangeClick}
              aria-label={t.changeDeed || "Tat ändern"}
              data-testid="change-deed-button"
            >
              <RefreshCw size={14} />
              <span>{t.changeDeed || "Andere Tat"}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeedCard;
